import React, { useState } from 'react';
import cls from 'classnames';

import './styles.css';

import Spreader from '../Spreader';
import Appearance from '../Appearance';
import Banner, { DIRECTIONS } from '../Banner';
import Anchor, { SECTIONS, scrollTo } from '../Anchor';

import { TYPES, CONFIG } from './constants';
import useWindowSize from '../utils/useWindowSize';

const Slide = props => {
  const { type, className, isMobile } = props;

  const viewConfig = CONFIG[type];

  const backToMap = () => {
    scrollTo(SECTIONS.TECHNOLOGIES_MAP);
  };
  return (
    <div className={cls('Technologies__slide', className)}>
      <div className="Technologies__banner-content">
        <div className="Technologies__banner-title">{viewConfig.title}</div>
        {viewConfig.text}
        {!!viewConfig.link && (
          <div className="Technologies__link-wrap">
            <a className="Technologies__link" href={viewConfig.link}>
              Подробнее
            </a>
          </div>
        )}
        {
          !isMobile
          &&
          <div className="Technologies__link-wrap">
            <span className="Technologies__link" onClick={backToMap}>
              Назад
            </span>
          </div>
        }
      </div>
      {!!viewConfig.image && (
        <div className="Technologies__banner-story">
          <div
            className={`Technologies__banner-image ${viewConfig.image}`}
          ></div>
        </div>
      )}
      {
          isMobile
          &&
          <div className="Technologies__link-wrap--isMobile">
            <span className="Technologies__link" onClick={backToMap}>
              Назад
            </span>
          </div>
        }
    </div>
  );
};

export default props => {
  const size = useWindowSize();
  const isMobile = size.width < 700;

  const [isShow, setShow] = useState(true);
  const [activeType, setActiveType] = useState(TYPES.game);

  const handleClick = selectedType => {
    setShow(false);
    scrollTo(SECTIONS.TECHNOLOGIES_DESCRIPTION);
    setTimeout(() => {
      setActiveType(selectedType);
      setShow(true);
    }, 300);
  };

  return (
    <div className="Technologies" style={props.style}>
      <Spreader>
        <div className="Technologies__title-wrap">
          <Banner
            direction={DIRECTIONS.LEFT}
            title="8 сфер, где 5G сделает революцию"
          >
            5G станет прорывом не только для самих телекоммуникаций. Новое
            поколение связи для мира может стать чем-то вроде форсажа для
            двигателя. Рассмотрим несколько областей применения нового стандарта
            связи – там, где 5G будет особенно полезен.
          </Banner>
        </div>
      </Spreader>
      <div className="Technologies__image"></div>
      <Spreader>
        <Anchor section={SECTIONS.TECHNOLOGIES_MAP} />
        <div className="Technologies__map">
          {Object.values(TYPES).map(type => (
            <div
              className={cls(
                'Technologies__map-point',
                `Technologies__map-point--${type}`,
                {
                  'Technologies__map-point--isSelected': type === activeType,
                }
              )}
              key={type}
              onClick={handleClick.bind(null, type)}
            ></div>
          ))}
        </div>
        <Anchor section={SECTIONS.TECHNOLOGIES_DESCRIPTION} />
        <Appearance type="right">
          <Banner
            direction={DIRECTIONS.LEFT}
            noPaddings
            style={{ borderRadius: '0 50px 0 0' }}
          >
            <Slide
              type={activeType}
              isMobile={isMobile}
              className={cls('Technologies__slide-wrap', {
                'Technologies__slide-wrap--isHide': !isShow,
              })}
            />
          </Banner>
        </Appearance>
      </Spreader>
    </div>
  );
};

/*
        }
        {
          isMobile
          &&
          <div>
            {Object.values(TYPES).map((type, idx) => (
              <Appearance type="right" key={idx}>
                <Slide type={type} />
              </Appearance>
            ))}
          </div>
        }
*/
